import { http } from "./config";

export default {
  listarinis: () => {
    return http.get("inis.php");
  },
  listarInisCd: (cd) => {
    return http.get("inis.php?cd=" + cd);
  },
  listarinisvalores: () => {
    return http.get("inis.php");
  },
  buscafone: (cdf) => {
    return http.get("inis.php?cd=" + cdf);
  },
  buscaentrega: (cde) => {
    return http.get("inis.php?cd=" + cde);
  },
  buscaretirada: (cdr) => {
    return http.get("inis.php?cd=" + cdr);
  },
};
